module.exports = __webpack_public_path__ + "cdd3cf17c7030c406aa277ad2bf1c3c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/logo.jpg
// module id = 1044
// module chunks = 0